import BasicContainersQuery from "./basic_containers";
import ContainersIntermediated from "./containers_intermediated"

export default [...BasicContainersQuery, ...ContainersIntermediated];
